import { StoreResponse, StoreRequest } from '../../../core/models/mxp-store.model';
import { MxpStoreService } from '../../../core/services/mxp-store.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { GetAccountsByCurrentUserMerchantHttpResponse, MerchantAccountHttpResponse } from '../../../core/models/mxp-account.model';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CountriesEnum } from '../../../core/enums/countries.enum';
import { BaseDropDownItem, BaseDropDownItemUtils } from '@rezolved/ui';
import { MxpSnackBarService } from '../../../core/services/mxp-snackbar.service';
import { NumberPatternEnum } from 'libs/ui/src/lib/enums/number-pattern.enum';

@Component({
  selector: 'mxp-store-edit-form',
  templateUrl: './store-form.component.html',
  styleUrls: ['./store-form.component.scss'],
})
export class StoreFormComponent {
  form: FormGroup;

  isAdmin = true;
  isLoading = false;
  countries: BaseDropDownItem[];
  accounts: BaseDropDownItem[] = [];
  accountTypes: BaseDropDownItem[];
  phoneFieldHasErrors = false;
  pattern = NumberPatternEnum.POSITIVE_DECIMAL;
  constructor(
    @Inject(MAT_DIALOG_DATA) public store: StoreResponse,
    public dialogRef: MatDialogRef<StoreFormComponent>,
    private mxpStoreService: MxpStoreService,
    private http: HttpClient,
    private mxpSnackBarService: MxpSnackBarService,
    private dialog: MatDialog,
  ) {
    this.countries = BaseDropDownItemUtils.transformEnum(CountriesEnum);
    this.accountTypes = BaseDropDownItemUtils.transformList([this.accountType]);
    this.form = new FormGroup({
      name: new FormControl(store.name, Validators.required),
      street1: new FormControl(store.street1, Validators.required),
      city: new FormControl(store.city, Validators.required),
      state: new FormControl(store.state, Validators.required),
      zip: new FormControl(store.zip, Validators.compose([Validators.required, Validators.pattern('\\d+'), Validators.maxLength(5)])),
      country: new FormControl(store.country, Validators.required),
      phone: new FormControl(store.phone, Validators.compose([Validators.required, Validators.pattern('\\+?\\d+')])),
      callbackurl: new FormControl(store.callbackWebhookUrl, Validators.compose([Validators.pattern(
        '^([a-zA-Z]+:\\/\\/)' + // protocol
        '((([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
        '(\\:\\d+)?(\\/[-a-zA-Z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-zA-Z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-zA-Z\\d_]*)?$')])),
      accountId: new FormControl(store.accountId || '')
    });
    this.form.get('phone')?.valueChanges.subscribe((x) => {
      if (x && x !== store.phone) {
        this.form.markAsTouched();
      }
      this.phoneFieldHasErrors = false;
    });
    this.form.get('accountId')?.valueChanges.subscribe(() => {
      this.form.markAsTouched();
    });
    this.form.markAsUntouched();
    this.loadValidatedAccounts();
  }



  get country(): string {
    return this.form.get(`country`)?.value || ``;
  }

  get accountType(): string {
    return this.store.pspId || ``;
  }

  handlePhoneFieldError() {
    this.phoneFieldHasErrors = true;
  }

  save = () => {
    this.isLoading = true;

    const { name, street1, street2, city, state, zip, country, phone, accountId } = this.form.value;
    const callbackWebhookUrl: string = this.form.get('callbackurl')?.value;

    const updateRequest: StoreRequest = {
      name,
      street1,
      city,
      state: state,
      zip: zip,
      country,
      phone,
      callbackWebhookUrl,
      accountId: accountId || null
    };

    var response = this.mxpStoreService.updateStore(this.store.id, updateRequest);
    response.subscribe(
      () => {
        this.isLoading = false
        const targetMessage = 'SNACKBAR.UPDATE_STORE';
        this.mxpSnackBarService.showSnackbarMessage(targetMessage);
        this.dialogRef.close(updateRequest);
      },
      (error) => {
        this.isLoading = false
        this.mxpSnackBarService.showSnackbarMessage('SNACKBAR.UPDATE_STORE_FAIL');
      }
    );
  };

  private loadValidatedAccounts(): void {
    this.isLoading = true;

    this.mxpSnackBarService
      .wrapApiCall(
        'SNACKBAR.GET_ACCOUNTS',
        this.http.get<GetAccountsByCurrentUserMerchantHttpResponse>(`${environment.identityUrl}/api/mxp-accounts/current-user-merchant`),
        undefined,
        undefined,
        undefined,
        true,
      )
      .subscribe(
        (response: GetAccountsByCurrentUserMerchantHttpResponse) => {
          this.accounts = [
            { key: 'NO_ACCOUNT', value: '' },
            ...(response.accounts || [])
              .filter((account) => account.validationStatus === 'ValidationSucceded')
              .map((account) => this.toAccountDropDownItem(account)),
          ];

          if (!this.form.get('accountId')?.value && this.store.accountNumber) {
            const selectedAccount = this.accounts.find((account) => account.key === this.store.accountNumber);
            this.form.get('accountId')?.setValue(selectedAccount?.value || '', { emitEvent: false });
            this.form.markAsUntouched();
          }

          this.isLoading = false;
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
        },
      );
  }

  private toAccountDropDownItem(account: MerchantAccountHttpResponse): BaseDropDownItem {
    return {
      key: account.accountNumber || '',
      value: account.accountId || '',
    };
  }

}
